import React, { useEffect, useState } from "react";
import "./Newsletter.css";
import Artist_navbar from "../Artist_navbar";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";
import Patron_Navbar from "../../PatronPages/Patron_Navbar";

// Sidebar imports
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FaUser,
  FaBriefcase,
  FaBook,
  FaNewspaper,
  FaSignOutAlt,
  FaIdBadge,
  FaEnvelope,
} from "react-icons/fa";
import "../Dashboard/dashboard.css";
import Sidebar from "../../../components/Sidebar";
// Redux imports for logout
import { useSelector, useDispatch } from "react-redux";
import { setAccessToken, setRefreshToken } from "../../reducer/slices/authSlice";
import { toast } from "react-toastify";

const API_KEY = "abd2a54ab4276195b304f44c5f94e68a";
// const API_URL = `https://gnews.io/api/v4/search?q=traditional%20art&lang=en&country=in&max=20&apikey=${process.env.REACT_APP_NEWS_API_KEY}`;
const API_URL = `https://gnews.io/api/v4/search?q=traditional%20art&lang=en&country=in&max=20&apikey=abd2a54ab4276195b304f44c5f94e68a`;

export function Newsletter() {
  const [Role, setRole] = useState("");
  const [latestNews, setLatestNews] = useState(null);
  const [imageNews, setImageNews] = useState(null);
  const [relatedNews, setRelatedNews] = useState([15, 16, 17]);
  const [loading, setLoading] = useState(false);
  
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Logout function - Dashboard jaisa
  const handleLogout = () => {
    dispatch(setAccessToken(null));
    dispatch(setRefreshToken(null));
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("role");
    toast.success("Successfully logged out", { position: "top-center" });
    navigate("/login");
  };


  const fetchNews = async () => {
    setLoading(true);
    return fetch(API_URL)
      .then((response) => response.json())
      .then((data) => data)
      .catch((error) => {
        throw new Error("Error fetching new data :", error);
      });
  };

  const newsId = [3, 4, 5, 6, 7, 8];

  useEffect(() => {
    fetchNews()
      .then((data) => {
        setLatestNews(data.articles);
        console.log(data);
        const image = data.articles.filter((item) => item.url);
        console.log("image", image);
        setImageNews(image);
        setLoading(false);
      })
      .catch((error) => console.error("Error fetching news data :", error));
  }, []);

  return (
    imageNews !== null && (
      <>
      <Artist_navbar /> 

        {/* Layout wrapper - only for Artist */}
  
          <div className="dashboard-layout">
            {/* Dashboard layout wrapper */}
            <Sidebar />

            {/* -------- Main Content -------- */}
            <main className="dashboard-content">
              {/* Main content wrapper */}
              {loading ? (
                <div className="performances_loading">
                  <div className="performances_spinner" />
                </div>
              ) : (
                <div className="NewsletterPage">
                  <div className="latest_news_wrapper">
                    <h1 className="latest_news_text">Latest News</h1>

                  <div className="latest_news_container">
                    {newsId.map((data, index) => (
                      <div key={index} className="single_latest_news_wrapper">
                        <div className="single_latest_news">
                          <img
                            className="latest_news_img"
                            onClick={() => (window.location.href = imageNews[data].url)}
                            src={imageNews[data].image}
                            alt=""
                          />
                          <div className="latest_news_title" style={{ padding: 4 }}>
                            {imageNews[data]?.title?.split(" ").slice(0, 15).join(" ")}
                            ...
                          </div>
                        </div>
                        <div className="single_news_details">
                          {imageNews[data]?.author && (
                            <div className="NewsletterPage_Article_Content_Profile">
                              <img src="../assets/Newsletter/Profile.png"></img>
                              <p className="single_news_author">{imageNews[data]?.author} </p>
                            </div>
                          )}

                          <p className="single_news_name">{imageNews[data]?.source?.name} </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                </div>
              )}
            </main>
          </div>
        
      </>
    )
  );
}